import { render, staticRenderFns } from "./LamsBaseLegalArchiveReference.vue?vue&type=template&id=d0682c1e&scoped=true&"
import script from "./LamsBaseLegalArchiveReference.vue?vue&type=script&lang=js&"
export * from "./LamsBaseLegalArchiveReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0682c1e",
  null
  
)

export default component.exports